import OnboardingPopup from './OnboardingPopup.component';

export default OnboardingPopup;